import { render, staticRenderFns } from "./CardChartName.vue?vue&type=template&id=2995df3c&"
import script from "./CardChartName.vue?vue&type=script&lang=js&"
export * from "./CardChartName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports